// @ts-nocheck
/**
 * 定制化功能模块，如菜单的配置、地图服务配置、字段的配置等
 */
import axios from 'axios'
import { postApiJSON, postApiData, allApi } from './common'

const mapResourceApi = {
  // 周边配套字典表
  selectDicFacility(params) {
    return postApiJSON('/openApi/selectDicFacility', params)
  },
  // 获取地块列表，显示地图地块
  getLandInfoList(params) {
    return postApiData('/openApi/selectLandInfoList', params)
  },
  // 获取地块详情
  getLandInfoById(params) {
    return postApiData('/openApi/getLandInfoById', params)
  },
  getPhotoSphereMarkerListById(params) {
    return postApiData('/openApi/getPhotoSphereMarkerListById', params)
  },
  getLandInfoAndMatchingById(params) {
    return postApiData('/openApi/getLandInfoAndMatchingById', params)
  },

  getRegulationsList(params) { // 分页查询所有政策法规
    return postApiJSON('/openApi/getRegulationsList', params)
  },
  // 获取招商联系人
  getInvestmentLinkList(params) {
    return postApiJSON('/openApi/getInvestmentLinkList', params)
  },
  // 获取咨询问题列表
  getProblemList(params) {
    return postApiJSON('/openApi/getProblemList', params)
  },
  // 添加咨询问题
  addProblem(params) {
    return postApiJSON('/openApi/addProblem', params)
  },
  // 修改地块信息浏览次数
  updateLandInfoVisitcount(params) {
    return postApiData('/openApi/updateLandInfoVisitcount', params)
  },
  selectByCityName(params) {
    return postApiData('/openApi/selectByCityName', params)
  },

  // 高德地图周边搜索
  gaodeAroundSearch(paramsArr) {
    const promiseArray = []
    for (let i = 0; i < paramsArr.length; i++) {
      const params = paramsArr[i]
      promiseArray.push(axios.get(`${gaodeApi}`, {params}))
    }
    return allApi(promiseArray)
  },
  addOrUpdateLandInfo(params) {
    return postApiJSON('/api/tLandinfo/addOrUpdate', params)
  },

  deleteLandmatching(params) {
    return postApiData('/api/tLandmatching/deleteByDkId', params)
  }
}

export {
  mapResourceApi
}
